import { makeStyles } from "@material-ui/core";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import * as React from "react";
import { cloneElement } from "react";
import {
	CreateButton,
	ExportButton,
	sanitizeListRestProps,
	TopToolbar,
	useListContext,
	useTranslate,
} from "react-admin";
import CommandButton from "../components/buttons/CommandButton";

const useStyles = makeStyles((theme) => ({
	button: {
		"& .MuiButton-label": {
			alignItems: "start",
			"& span": {
				whiteSpace: "nowrap",
			},
		},
	},
}));

const Actions = ({ permissions, ...props }) => {
	const classes = useStyles();
	const { className, exporter, filters, maxResults, ...rest } = props;
	const {
		currentSort,
		resource,
		displayedFilters,
		filterValues,
		showFilter,
		total,
		basePath,
	} = useListContext();
	const translate = useTranslate();
	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{filters &&
				cloneElement(filters, {
					resource,
					showFilter,
					displayedFilters,
					filterValues,
					context: "button",
					className: classes.button,
				})}
			<CreateButton resource={resource} basePath={basePath} />
			<ExportButton
				disabled={total === 0}
				resource={resource}
				sort={currentSort}
				filterValues={filterValues}
				maxResults={maxResults}
				className={classes.button}
			/>
			{permissions && permissions("admin") && (
				<CommandButton
					isButton={true}
					color="primary"
					className={classes.button}
					icon={<ContactMailIcon />}
					label={translate("resources.users.buttons.sendinblue_export")}
					notifySuccess={translate(
						"resources.users.messages.sendinblue_export_success"
					)}
					confirmTitle={translate("resources.users.titles.sendinblue_export")}
					confirmContent={translate(
						"resources.users.messages.sendinblue_export"
					)}
					command={{
						name: "sendinblue",
						args: ["import"],
						notify_args: {
							title: translate(
								"resources.users.messages.sendinblue_export_notify_title"
							),
							content: translate(
								"resources.users.messages.sendinblue_export_notify_content"
							),
							resource: "users",
						},
					}}
				/>
			)}
		</TopToolbar>
	);
};

export default Actions;
